import {
  Box,
  Flex,
  Heading,
  HStack,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { TbLock } from "react-icons/tb";
import { useParams } from "react-router-dom";
import EmptyState from "components/ds/EmptyState";
import { MF_ACCESS } from "state/members/access_v2/catalogs";
import SearchBox from "ui/SearchBox";
import CatalogTiles from "./CatalogTiles";
import "./styles.css";

const Catalogs = () => {
  const { id } = useParams();
  const access = MF_ACCESS.useGetAccessCatalog(id);
  const [search, setSearch] = useState("");

  if (access.status === "loading") {
    return (
      <Flex w="full" minH="60vh" justify="center" align="center">
        <Spinner />
      </Flex>
    );
  }

  if (access.status === "no-access") {
    return (
      <Flex w="full" minH="60vh" justify="center" align="center">
        <EmptyState
          icon={<TbLock />}
          title="You don't have access to this catalog"
          body="This access catalog isn't available to you. If you think this is a mistake, contact your administrator."
        />
      </Flex>
    );
  }

  const selected = access.catalog;

  return (
    <Flex
      w="full"
      h="full"
      px={0}
      minH="100vh"
      align="flex-start"
      direction="column"
    >
      <HStack mb={4} justify="space-between" w="full">
        <VStack align="flex-start" spacing={1}>
          <Heading size="md" fontWeight="500" color="gray.800">
            {selected.name}
          </Heading>
          <Text variant={"lil"}>{selected.description}</Text>
        </VStack>
      </HStack>
      <VStack
        w="full"
        maxW="1200px"
        h="full"
        spacing={6}
        pb={10}
      >
        <VStack spacing={4} w="full" align="flex-start">
          <HStack w="full">
            <Box w="400px">
              <SearchBox w="100%" onChange={(e) => setSearch(e.target.value)} />
            </Box>
          </HStack>
        </VStack>
        <CatalogTiles selected={selected} search={search} id={selected.id} />
      </VStack>
    </Flex>
  );
};
export default Catalogs;
